module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "epigraph"
    }
  }, [_vm._v("In the seventh century, the Toltecs, an agricultural people, moved from northern Mexico down into the vicinity of Mexico City. In all of history, there was never a people more civilized or humane. According to the old histories, the Toltecs went to war with wooden swords—so that they would not kill their enemies.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('b', [_c('i', [_vm._v("The Book of Lists")])])]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("For they sleep not, except they have done mischief; and their sleep is taken away, unless they cause some to fall.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For they eat the bread of wickedness, and drink the wine of violence.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('b', [_c('i', [_vm._v("Proverbs")]), _vm._v(" 4:16–17")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("There was a time, believe it or not, when human beings did each other harm. In the chaotic ages preceding the Stromboli Solution, torture, rape, war, and murder happened almost daily. Violence reigned like a soulless despot. Self-defense was a growth industry.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("Scholars today agree that, of all the pre-Stromboli schemes for conquering aggression, only one merits preservation in our collective memory.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("This is the story of Quetzalia.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b04404","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/0-epigraph.vue
// module id = 78
// module chunks = 0